export default __webpack_public_path__ + "media/images/images/portfolio/width-1200/portfolio-1-f3a57293766d908d1163619d1f074e94.jpg";